export enum EnmState {
    Created = 0,
    Started = 5,
    Suspended = 8,
    Completed = 10,
    Aborted = 20,
    Archived = 45,
    Deleted = 50
}